import { cssInterop } from 'nativewind'
import React, { forwardRef } from 'react'
import { Pressable as RNPressable, PressableProps, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { FOCUS_RING_CLASS } from '../../focusRing'

cssInterop(RNPressable, { className: 'style' })

export type { PressableProps }

export const Pressable = forwardRef<View, PressableProps & { className?: string }>(
    function Pressable({ className, ...props }, ref) {
        // The focus ring goes only on pressables that announce themselves as a control.
        // react-native-web makes EVERY pressable a tab stop whatever its role, and plenty
        // of them are plain containers — whole dashboard tiles, list rows. Ringing those
        // would draw a full-tile outline around something that has no accessible name, so
        // the roleless ones stay as they were. Callers that need the ring on a roleless
        // element can merge `FOCUS_RING_CLASS` (exported) themselves.
        //
        // Ring first in the merge, so a caller's own className still overrides it.
        const isControl = props.accessibilityRole !== undefined || props.role !== undefined
        return (
            <RNPressable
                ref={ref}
                {...props}
                className={twMerge(isControl && FOCUS_RING_CLASS, className)}
            />
        )
    },
)

Pressable.displayName = 'Pressable'
